import RichTextEditor from '../rich-text-editor/RichTextEditor';
import { helpClass } from './ui';

// ai-api's limit for a saved answer.
export const ANSWER_MAX_LENGTH = 8000;

export const answerTooLong = (answer: string) => answer.trim().length > ANSWER_MAX_LENGTH;

export const ANSWER_TOO_LONG = `Answers can be up to ${ANSWER_MAX_LENGTH.toLocaleString('en-US')} characters.`;

interface AnswerEditorProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  readOnly?: boolean;
  minHeight?: string;
}

/** An answer, in the rich text editor's visual mode with its basic toolbar, and its length. */
export default function AnswerEditor({ value, onChange, label, readOnly = false, minHeight = '12rem' }: AnswerEditorProps) {
  const over = value.trim().length > ANSWER_MAX_LENGTH;
  return (
    <>
      <RichTextEditor
        value={value}
        onChange={onChange}
        defaultRawMode={false}
        toolbarVariant="basic"
        readOnly={readOnly}
        height="auto"
        minHeight={minHeight}
        placeholder="Write the answer"
        ariaLabel={label}
      />
      <p className={over ? 'mt-1 text-xs text-red-600' : helpClass}>
        {value.length.toLocaleString('en-US')} / {ANSWER_MAX_LENGTH.toLocaleString('en-US')}
      </p>
    </>
  );
}
